import React,{ Component } from 'react';
import { connect } from 'react-redux';
import Actions from '../../../Actions';
import Confirm from '../Layout/Confirm';
import { getRole, sanitizeData } from '../../../Utilities/Common';

class UserRow extends Component{

    render(){
        let { id, name, email, role, mail_subscription } = sanitizeData(this.props.user);
        const userRole = getRole(role);
        const { token, deleteUser, sendDetails, edit } = this.props;   
        return (
            <tr key={id+200}>
                <td><span style={{cursor: "pointer"}} onClick={() => edit(id)} className="btn-link">{name}</span></td><td>{email}</td><td>{userRole.name}</td><td>{mail_subscription === 0 ? "Unsubscribed": <span style={{color:"red"}}>Subscribed</span>}</td><td><Confirm icon='Send' confirm={() => sendDetails(token, email)}/></td><td><Confirm icon='Trash2' confirm={() => deleteUser(token,id)} /></td>
            </tr>
        );
    }
}

const mapStateToProps = (state) => ({
    token: state.auth.token,
});
export default connect(mapStateToProps,Actions.users)(UserRow);


// WEBPACK FOOTER //
// ./src/Components/App/Users/UserRow.js